const designRouter = [
  {
    path: 'home',
    name: 'home',
    component: () => import('@/views/wxapp/designer-manager/home/index'),
    meta: {
      title: '设计师'
    }
  },
  // {
  //   path: 'informationList',
  //   name: 'informationList',
  //   component: () => import('@/views/wxapp/designer-manager/home/informationList/index'),
  //   meta: {
  //     title: '消息提醒'
  //   }
  // },
  {
    path: 'designPage',
    name: 'designPage',
    component: () => import('@/views/wxapp/designer-manager/home/designPage/index'),
    meta: {
      title: '设计师服务流程'
    }
  },
  {
    path: 'quotationOrder',
    name: 'quotationOrder',
    component: () => import('@/views/wxapp/designer-manager/quotationOrder'),
    meta: {
      title: '订单报价'
    }
  },
  {
    path: 'contract',
    name: 'contract',
    component: () => import('@/views/wxapp/designer-manager/contract'),
    meta: {
      title: '合同签约'
    }
  },
  {
    path: 'contract/create',
    name: 'contract',
    component: () => import('@/views/wxapp/designer-manager/contract/create'),
    meta: {
      title: '合同签约'
    }
  },
  {
    path: 'checkoutCounter',
    name: 'checkoutCounter',
    component: () => import('@/views/wxapp/designer-manager/checkoutCounter/index.vue'),
    meta: {
      title: '款项缴纳'
    }
  },
  {
    path: 'contract/e-contract/:cid/:token',
    name: 'eContract',
    component: () => import('@/views/wxapp/designer-manager/contract/eContract'),
    meta: {
      title: '合同签约'
    },
    props: true
  },
  {
    path: 'e-contract-completed/:cid/:token',
    name: 'completed',
    component: () => import('@/views/wxapp/designer-manager/contract/eContract/completed.vue'),
    meta: {
      title: '合同详情'
    },
    props: true
  },
  {
    path: 'contract/e-contract-sendemail/:cid/:token/:email',
    name: 'sendEmail',
    component: () => import('@/views/wxapp/designer-manager/contract/eContract/sendEmail.vue'),
    meta: {
      title: '发送邮件'
    },
    props: true
  },
  {
    path: 'contract/offlineInfo/:cid',
    name: 'offlineInfo',
    component: () => import('@/views/wxapp/designer-manager/contract/eContract/offlineInfo.vue'),
    meta: {
      title: '合同详情'
    },
    props: true
  },
  {
    path: 'contract/e-contract-emailcompleted/:cid/:token',
    name: 'sendEmailCompleted',
    component: () => import('@/views/wxapp/designer-manager/contract/eContract/sendEmailCompleted.vue'),
    meta: {
      title: '邮件发送成功'
    },
    props: true
  },
  {
    path: 'confessionInvitation',
    name: 'confessionInvitation',
    component: () => import('@/views/wxapp/designer-manager/confessionInvitation'),
    meta: {
      title: '交底邀约'
    }
  },
  {
    path: 'inputForm',
    name: 'inputForm',
    component: () => import('@/views/wxapp/designer-manager/inputForm'),
    meta: {
      title: '订单报价'
    }
  },
  {
    path: 'demandFile',
    name: 'demandFile',
    component: () => import('@/views/wxapp/designer-manager/demandFile'),
    meta: {
      title: '查看需求档案'
    }
  },
  {
    path: 'serviceManual',
    name: 'serviceManual',
    component: () => import('@/views/wxapp/designer-manager/serviceManual'),
    meta: {
      title: '服务手册'
    }
  },
  {
    path: 'waitingUser',
    name: 'WaitingUser',
    component: () => import('@/views/wxapp/designer-manager/waitingUser'),
    meta: {
      title: '待接收用户'
    }
  }
]
export default designRouter
